import { render, staticRenderFns } from "./OrderActionsModal.vue?vue&type=template&id=6c82d60a&scoped=true"
import script from "./OrderActionsModal.vue?vue&type=script&lang=js"
export * from "./OrderActionsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderActionsModal.vue?vue&type=style&index=0&id=6c82d60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82d60a",
  null
  
)

export default component.exports